export default {
  methods: {
    apiUpdate(url, params, loading, showMsgSuccess) {
        return new Promise((resolve, reject) => {
            this.$http.put(url, params, loading, showMsgSuccess).then((response) => {
                if (response.success) {
                    resolve(response)
                }
            }, (error) => {
                reject(error)
            });
        })

    },

    apiCreate(url, params, loading, showMsgSuccess) {
        return new Promise((resolve, reject) => {
            this.$http.post(url, params, loading, showMsgSuccess).then((response) => {
                if (response.success) {
                    resolve(response)
                }
            }, (error) => {
                reject(error)
            });
        })

    },
  }

}